var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreatments = function SvgTreatments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M8.399 4.029a.525.525 0 1 0 .35-.525h-1.75a3.5 3.5 0 0 0-3.5 3.5v8.75a10.5 10.5 0 0 0 21 0v-8.75a3.5 3.5 0 0 0-3.5-3.5h-1.75a.371.371 0 0 0 .525.525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M13.999 26.25V28a10.5 10.5 0 0 0 21 0v-7M35 20.999a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
  })));
};
export default SvgTreatments;